import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetResumeV2Domain = (state) =>
  state.get("widgetResumeV2", initialState)

export const makeSelectIsLoadingEvolutionMeasure = () =>
  createSelector(selectWidgetResumeV2Domain, (state) =>
    state.get("isLoadingEvolutionMeasure")
  )

export const makeSelectEvolutionData = () =>
  createSelector(selectWidgetResumeV2Domain, (state) =>
    state.get("evolutionData")
  )

export const makeSelectEvolutionLines = () =>
  createSelector(selectWidgetResumeV2Domain, (state) =>
    state.get("evolutionLines")
  )

export { selectWidgetResumeV2Domain }
